<template>
    <div class="column">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Incharge</label>
            </div>
            <div class="field is-expanded remarks">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-user-tie"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input class="input" type="text" v-model="incharge" readonly>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Paid*</label>
            </div>
            <div class="field">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-wallet"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input class="input" type="number" v-model="paidAmount" placeholder="Amount been paid.">
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            incharge: {
                get() {
                    return this.$store.getters.getCustomInvoice.incharge
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'incharge', value: value})
                }
            },
            paidAmount: {
                get() {
                    return this.$store.getters.getCustomInvoice.paid_amount
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'paid_amount', value: value})
                }
            }
        }
    }
</script>

<style scoped>
    .field-label {
        flex-grow: 0;
    }
    .field-label .label {
        font-size: medium !important;
    }
    .remarks {
        width: 93%;
    }
    .label {
        white-space: nowrap;
        min-width: 100px;
    }
    .is-static {
        min-width: 50px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceInCharge.vue